import React from "react"
import { CreateEventForm } from "../../../components/CreateEventForm"

export const CreateEventPage = () => {
  return (
    <div>
      <CreateEventForm />
    </div>
  )
}
